import { collateErrors as collatePasswordErrors } from '@ynap/password-input';

export default function collateErrors(values, props, json) {
    let errors = {};
    const { messages } = props;

    const passwordErrors = collatePasswordErrors(values, props, json);

    if (json && json.errors) {
        json.errors.forEach(({ errorKey, errorParameters }) => {
            switch (errorKey) {
                case '_ERR_LOGONID_ALREDY_EXIST':
                    errors._error = errors.registrationEmail = messages.errors.userExists();
                    break;
                case '_ERR_MISSING_CMD_PARAMETER':
                    errors._error = errors[errorParameters.split(',')[0]] = messages.errors.required({ field: errorParameters.split(',')[0] });
                    break;
                case '_ERR_VALUE_FOR_PARM_NOT_SUPPORTED':
                    errors._error = errors[errorParameters.split(',')[0]] = messages.errors.required({ field: errorParameters.split(',')[0] });
                    break;
            }
        });
    }

    const _error = !Object.keys(errors).length && !Object.keys(passwordErrors).length ? messages.errors.global() : undefined;

    return { _error, ...errors, ...passwordErrors };
}
